// core/route-fallback.js — placeholders de rota enquanto um chunk lazy é baixado
// ou quando o carregamento falha (ex.: offline).
//
// Usado pelo main.js para rotas `lazy` (Fase 9). Mantém a identidade visual
// (header vermelho Eloquence + área principal) para não "piscar" entre
// skeleton e conteúdo real.
//
// Exporta:
//   renderRouteSkeleton(container, titulo)
//   renderRouteError   (container, titulo, err)

const HEADER = titulo => `
  <header style="background:linear-gradient(90deg,#6A001F,#B3002D);padding:calc(env(safe-area-inset-top,0px)+16px) 20px 16px;position:sticky;top:0;z-index:100">
    <div style="display:flex;align-items:center;gap:14px">
      <div style="width:38px;height:38px;border-radius:50%;background:rgba(255,255,255,0.18);flex-shrink:0"></div>
      <div>
        <div style="font-size:10px;font-weight:600;color:rgba(255,255,255,0.65);letter-spacing:2px;text-transform:uppercase">Admin</div>
        <div style="font-size:20px;font-weight:800;color:#fff">${titulo}</div>
      </div>
    </div>
  </header>`;

const SHELL = titulo => `
  <div style="min-height:100vh;background:#F5F5F5;font-family:'Montserrat',sans-serif;">
    ${HEADER(titulo)}
    <main style="padding:20px">`;

const SHELL_CLOSE = `</main></div>`;

/**
 * Placeholder de loading enquanto um chunk de rota lazy é baixado.
 * Barras cinza animadas evocam o skeleton — CSS inline para não depender
 * de nenhum estilo global.
 */
export function renderRouteSkeleton(container, titulo = 'Carregando...') {
  container.innerHTML = `
    ${SHELL(titulo)}
      <div aria-live="polite" aria-busy="true" style="display:flex;flex-direction:column;gap:14px">
        ${[72, 120, 96, 180].map(h => `
          <div class="eloq-skel" style="border-radius:14px;height:${h}px"></div>`).join('')}
      </div>
      <div style="text-align:center;margin-top:24px;font-size:12px;color:#9B9B9B;font-weight:600">
        Carregando módulo...
      </div>
    ${SHELL_CLOSE}`;
}

/**
 * Fallback quando o dynamic import falha (ex.: sem internet após um deploy
 * que invalidou o hash do chunk). Oferece um botão de refresh da página.
 */
export function renderRouteError(container, titulo, err) {
  console.error('[route-fallback]', titulo, err);
  const msg = (err && err.message) || 'Falha desconhecida';
  container.innerHTML = `
    ${SHELL(titulo)}
      <div style="background:#fff;border-radius:16px;padding:28px;text-align:center;box-shadow:0 2px 12px rgba(0,0,0,0.07)">
        <div style="font-size:42px;margin-bottom:12px">⚠️</div>
        <div style="font-size:16px;font-weight:800;color:#0A0A0A;margin-bottom:6px">Não foi possível carregar esta tela</div>
        <div style="font-size:12px;color:#9B9B9B;margin-bottom:16px;word-break:break-word">${msg}</div>
        <button id="routeErrReload" style="
          padding:10px 18px;background:linear-gradient(90deg,#6A001F,#B3002D);
          color:#fff;border:none;border-radius:10px;font-family:'Montserrat',sans-serif;
          font-size:13px;font-weight:700;cursor:pointer
        ">Recarregar app</button>
      </div>
    ${SHELL_CLOSE}`;

  const btn = container.querySelector('#routeErrReload');
  if (btn) btn.addEventListener('click', () => window.location.reload());
}
